import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getHeadquartersPharmacies } from '../../../../apis/jahisNsipsMatching'
import { GlobalState } from '../../../../stores/reducer'
import { queryKeys } from '../../../../shared'

/**
 * 本部アカウント向け薬局一覧を取得する Query hook
 *
 * is_headquarters=true の場合のみ有効化される。
 */
export const useHeadquartersPharmaciesQuery = (enabled: boolean) => {
  const isLoggedIn = useSelector((state: GlobalState) => state.isLoggedIn)

  return useQuery({
    queryKey: queryKeys.headquarters.pharmacies(),
    queryFn: async () => {
      const { data } = await getHeadquartersPharmacies()
      return data
    },
    enabled: isLoggedIn && enabled,
    staleTime: 10 * 60 * 1000, // 10分間キャッシュ
  })
}
